import React from 'react'
import { Table, TableBody, TableCell, TableRow, Text, Box } from 'grommet';
import styled from 'styled-components'

const TableCellMD = styled(TableCell)`
    text-align: center;
`

let MDColors = {
    nbid: "#0000C6",
    nask: "#AC0000",
    bid: "#0032FF",
    ask: "#DD0000",
    price: "#646464",
    ltp: "#F0F0F0"
}

let MGColors = {
    title: "#CDCDCD",
    grid: "#EEEEEE",
    bid: "#0032FF",
    ask: "#DD0000",
}

export class MarketDataModel {
    constructor() {
        this.bids = [];
        this.asks = [];
        this.settle = '';
        this.high = '';
        this.low = '';
        this.open = '';
        this.ltp = '';
        this.ltq = '';
        this.volume = '';
        this.source = '';
        this.updated = '';
    }

    parseSnapshot(snapshot, source){
        let svrBids = []
        snapshot.db.bids.forEach(each_prc => {
            svrBids.push({
                price: each_prc[0],
                qty: each_prc[1]
            })
        })


        let svrAsks = []
        snapshot.db.asks.forEach(each_prc => {
            svrAsks.push({
                price: each_prc[0],
                qty: each_prc[1]
            })
        })

        this.bids = svrBids;
        this.asks = svrAsks;

        this.settle = snapshot.stats_price.settle || this.settle;
        this.open = snapshot.stats_price.open || this.open;
        this.high = snapshot.stats_price.high || this.high;
        this.low = snapshot.stats_price.low || this.low;

        if (snapshot && snapshot.ltpq && snapshot.ltpq.length > 3) {
            this.ltp = snapshot.ltpq[0] || this.ltp;
            this.ltq = snapshot.ltpq[1] || this.ltq;
        }
        this.source = source;
        this.type = "edge"
    }

    parsePSSnapshot(snapshot, source){
        snapshot = JSON.parse(snapshot)
        this.parseSnapshot(snapshot, source)

        let exchange_ts = new Date(snapshot.db.exchange_ts/1000/1000)
        this.updated = ":" + exchange_ts.getMinutes() + ":" + exchange_ts.getSeconds() + "." + exchange_ts.getMilliseconds()
        this.type = "ps"
    }

    parseMDSSnapshot(snapshot, source) {
        snapshot = JSON.parse(snapshot)
        this.parseSnapshot(snapshot, source)
        let exchange_ts = new Date(snapshot.db.exchange_ts/1000/1000)
        this.updated = ":" + exchange_ts.getMinutes() + ":" + exchange_ts.getSeconds() + "." + exchange_ts.getMilliseconds()
        this.type = "mds"
    }

    parseEdgeSnapshot(snapshot) {
        let esBids = []
        snapshot && snapshot.bid && snapshot.bid.forEach(each_prc => {
            esBids.push({
                price: each_prc.p,
                qty: each_prc.q
            })
        })

        let esAsks = []
        snapshot && snapshot.ask && snapshot.ask.forEach(each_prc => {
            esAsks.push({
                price: each_prc.p,
                qty: each_prc.q
            })
        })

        this.bids = esBids;
        this.asks = esAsks;

        this.settle = snapshot.settle;
        this.open = snapshot.open;
        this.source = snapshot.edge;
        this.ltp = snapshot.lastprice;
        this.ltq = snapshot.lastqty;

        this.high = snapshot.high || this.high;
        this.low = snapshot.low || this.low;
        this.type = "edge"
        this.updated = snapshot.time
        this.volume = snapshot.volume
    }

    parseLive(snapshot) {
        let esBids = []
        snapshot.bids.forEach(each_prc => {
            esBids.push({
                price: each_prc.level.p,
                qty: each_prc.level.q
            })
        })

        let esAsks = []
        snapshot.asks.forEach(each_prc=> {
            esAsks.push({
                price: each_prc.level.p,
                qty: each_prc.level.q
            })
        })

        this.bids = esBids;
        this.asks = esAsks;

        if (snapshot.tradeData && snapshot.tradeData.td) {
            let td = snapshot.tradeData.td
            this.settle = td.s;
            this.open = td.o;
            this.low = td.l;
            this.high = td.h;

            this.ltp = td.tp;
            this.ltq = td.tq;
            this.volume = td.ttq;

            if (td.t){
                this.updated = new Date(
                    parseInt(td.t.substring(0, td.t.length-6))
                ).toISOString();
            }
        }
        this.type = "live"
    }
}

export const MDTrader = ({ mdmodel }) => {
    let MDRow = 0

    return (
        <Table>
            <TableBody>
                <TableRow>
                    <TableCell colSpan="4" background={MDColors.ltp} border={{side: 'all'}}>
                        <Text size="10px" color="black" weight="bold">Hostname: {mdmodel.source} [{mdmodel.type}]</Text>

                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCellMD size="100%" colSpan="3" background={MDColors.ltp} border={{ side: 'all' }}>
                        <Box direction="row">
                            <Text size="11px" color="black" margin="2px">H: {mdmodel.high}</Text>
                            <Text size="11px" color="black" margin="2px">O: {mdmodel.open}</Text>
                        </Box>
                        <Box direction="row">
                            <Text size="11px" color="black" margin="2px">L: {mdmodel.low}</Text>
                            <Text size="11px" color="black" margin="2px">S: {mdmodel.settle}</Text>
                        </Box>
                    </TableCellMD>
                    <TableCellMD size="0%" background={MDColors.ltp} border={{ side: 'all' }}>
                    </TableCellMD>
                </TableRow>
                {
                    // Building the Ask(s) descending
                    mdmodel.asks.sort((a, b) => (a.price > b.price) ? -1 : 1).map(each_prc => {
                        MDRow += 1
                        return (
                            <TableRow key={MDRow}>
                                <TableCellMD size="25%" background={MDColors.nbid} border={{ side: 'all' }}>

                                </TableCellMD>
                                <TableCellMD size="35%" background={MDColors.price} border={{ side: 'all' }}>
                                    <Text color='white' size="12px">
                                        {each_prc.price}
                                    </Text>
                                </TableCellMD>
                                <TableCellMD size="25%" background={MDColors.ask} border={{ side: 'all' }}>
                                    <Text color='black' size="12px">
                                        {each_prc.qty}
                                    </Text>
                                </TableCellMD>
                                <TableCellMD size="15%" background={MDColors.ltp} border={{ side: 'all' }}>
                                    {mdmodel.ltp === each_prc.price &&
                                        <Text color='black' size="11px" >
                                            {mdmodel.ltq}
                                        </Text>
                                    }
                                </TableCellMD>
                            </TableRow>
                        )
                    })
                }
                {
                    // Building the Bid(s) ascending
                    mdmodel.bids.sort((a, b) => (a.price < b.price) ? 1 : -1).map(each_prc => {
                        MDRow += 1
                        return (
                            <TableRow key={MDRow}>
                                <TableCellMD size="25%" background={MDColors.bid} border={{ side: 'all' }}>
                                    <Text color='white' size="12px">
                                        {each_prc.qty}
                                    </Text>
                                </TableCellMD>
                                <TableCellMD size="35%" background={MDColors.price} border={{ side: 'all' }}>
                                    <Text color='white' size="12px">
                                        {each_prc.price}
                                    </Text>
                                </TableCellMD>
                                <TableCellMD size="25%" background={MDColors.nask} border={{ side: 'all' }}>
                                </TableCellMD>
                                <TableCellMD size="15%" background={MDColors.ltp} border={{ side: 'all' }}>
                                    {mdmodel.ltp === each_prc.price &&
                                        <Text color='black' size="11px">
                                            {mdmodel.ltq}
                                        </Text>
                                    }
                                </TableCellMD>
                            </TableRow>
                        )
                    })
                }
                {
                    <TableRow key="Timestamp">
                        <TableCellMD colSpan="4" background={MDColors.ltp} border={{ side: 'all' }}>
                <Text color='black' size="11px">{mdmodel.updated} UTC</Text>
                        </TableCellMD>
                    </TableRow>
                }


            </TableBody>
        </Table>
    )
}


export const MarketGridHeader = () => {
    return (
        <TableRow key="MarketGridTitle">
            <TableCellMD background={MGColors.title} border={{ side: 'all' }}>
                <Text color='black' weight="bold" size="12px">Type</Text>
            </TableCellMD>
            <TableCellMD background={MGColors.title} border={{ side: 'all' }}>
                <Text color='black' weight="bold" size="12px">Host</Text>
            </TableCellMD>
            <TableCellMD background={MGColors.title} border={{ side: 'all' }}>
                <Text color='black' weight="bold" size="12px">Open</Text>
            </TableCellMD>
            <TableCellMD background={MGColors.title} border={{ side: 'all' }}>
                <Text color='black' weight="bold" size="12px">Settle</Text>
            </TableCellMD>
            <TableCellMD background={MGColors.title} border={{ side: 'all' }}>
                <Text color='black' weight="bold" size="12px">LTP</Text>
            </TableCellMD>
            <TableCellMD background={MGColors.title} border={{ side: 'all' }}>
                <Text color='black' weight="bold" size="12px">LTQ</Text>
            </TableCellMD>
            <TableCellMD background={MGColors.title} border={{ side: 'all' }}>
                <Text color='black' weight="bold" size="12px">Vol</Text>
            </TableCellMD>
            <TableCellMD background={MGColors.title} border={{ side: 'all' }}>
                <Text color='black' weight="bold" size="12px">BidQ</Text>
            </TableCellMD>
            <TableCellMD background={MGColors.title} border={{ side: 'all' }}>
                <Text color='black' weight="bold" size="12px">BidP</Text>
            </TableCellMD>
            <TableCellMD background={MGColors.title} border={{ side: 'all' }}>
                <Text color='black' weight="bold" size="12px">AskP</Text>
            </TableCellMD>
            <TableCellMD background={MGColors.title} border={{ side: 'all' }}>
                <Text color='black' weight="bold" size="12px">AskQ</Text>
            </TableCellMD>
            <TableCellMD background={MGColors.title} border={{ side: 'all' }}>
                <Text color='black' weight="bold" size="12px">Time</Text>
            </TableCellMD>
        </TableRow>
    )
}

export const MarketGridRow = ({ mdmodel, rowCount }) => {
    let marketbid = {
        price: "",
        qty: ""
    }
    if(mdmodel.bids.length > 0){
        marketbid = mdmodel.bids.sort((a, b) => (a.price < b.price) ? 1 : -1)[0]
    }

    let marketask = {
        price: "",
        qty: ""
    }
    if(mdmodel.asks.length > 0){
        marketask = mdmodel.asks.sort((a, b) => (a.price < b.price) ? -1 : 1)[0]
    }

    return(
        <TableRow key={"MarketGrid_" + rowCount}>
            <TableCellMD background={MGColors.grid} border={{ side: 'all' }}>
                <Text color='black' weight="bold" size="12px">{mdmodel.type}</Text>
            </TableCellMD>
            <TableCellMD background={MGColors.grid} border={{ side: 'all' }}>
                <Text color='black' weight="bold" size="12px">{mdmodel.source}</Text>
            </TableCellMD>
            <TableCellMD background={MGColors.grid} border={{ side: 'all' }}>
                <Text color='black' weight="bold" size="12px">{mdmodel.open}</Text>
            </TableCellMD>
            <TableCellMD background={MGColors.grid} border={{ side: 'all' }}>
                <Text color='black' weight="bold" size="12px">{mdmodel.settle}</Text>
            </TableCellMD>
            <TableCellMD background={MGColors.grid} border={{ side: 'all' }}>
                <Text color='black' weight="bold" size="12px">{mdmodel.ltp}</Text>
            </TableCellMD>
            <TableCellMD background={MGColors.grid} border={{ side: 'all' }}>
                <Text color='black' weight="bold" size="12px">{mdmodel.ltq}</Text>
            </TableCellMD>
            <TableCellMD background={MGColors.grid} border={{ side: 'all' }}>
                <Text color='black' weight="bold" size="12px">{mdmodel.volume}</Text>
            </TableCellMD>
            <TableCellMD background={MGColors.bid} border={{ side: 'all' }}>
                <Text color='white' weight="bold" size="12px">{marketbid.qty}</Text>
            </TableCellMD>
            <TableCellMD background={MGColors.bid} border={{ side: 'all' }}>
                <Text color='white' weight="bold" size="12px">{marketbid.price}</Text>
            </TableCellMD>
            <TableCellMD background={MGColors.ask} border={{ side: 'all' }}>
                <Text color='white' weight="bold" size="12px">{marketask.price}</Text>
            </TableCellMD>
            <TableCellMD background={MGColors.ask} border={{ side: 'all' }}>
                <Text color='white' weight="bold" size="12px">{marketask.qty}</Text>
            </TableCellMD>
            <TableCellMD background={MGColors.grid} border={{ side: 'all' }}>
                <Text color='black' weight="bold" size="12px">{mdmodel.updated}</Text>
            </TableCellMD>
        </TableRow>
    )
}